export default __webpack_public_path__ + "static/media/8-3.4e72ee5c.mp3";